/**
  * 接口域名的管理
  */
import ENV from './env.js'

let domainurl = "";
let restPath = '/Portal/rest';
let eduUlr; //本站地址
let caeaUrl; //caea.cn成教网站
let shequUrl; //社区大讲堂网址
let webLoginUrl; //网站公共登录页面
let webPersonalCenterUrl; //网站公共个人中心
let webRealInfoUrl; //实名认证页面
let authorUrl;
let redirect_uri;
let ossurl;

//本地环境、测试环境
if(ENV==0 || ENV==1){
    eduUlr = 'https://ceshi.artapp.cn/artedusharing/';
    caeaUrl = 'https://www.caea-art.cn';
    shequUrl = '//ceshi.artapp.cn/sharing'; 
    webLoginUrl = '//ceshi.artapp.cn/login?isShareSite=1';
    webPersonalCenterUrl = '//ceshi.artapp.cn/personalCenter'; 
    webRealInfoUrl = '//ceshi.artapp.cn/realInfo'; 
    authorUrl = '//ceshi.artapp.cn/AuthServer';
    redirect_uri = 'https://ceshi.artapp.cn/artedusharing/callback.html';
    ossurl = 'https://artapp-test-bucket.oss-cn-beijing.aliyuncs.com/';
}
//正式环境
else if(ENV==2){
    eduUlr = 'https://www.artedusharing.cn/';
    caeaUrl = 'https://www.caea-art.cn';
    shequUrl = '//sharing.artapp.cn'; 
    webLoginUrl = '//www.artapp.cn/login?isShareSite=1'; 
    webPersonalCenterUrl = '//www.artapp.cn/personalCenter'; 
    webRealInfoUrl = '//www.artapp.cn/realInfo'; 
    authorUrl = '//www.artapp.cn/AuthServer';
    redirect_uri = 'https://www.artedusharing.cn/callback.html';
    ossurl = 'https://artapp-dev-bucket.oss-cn-beijing.aliyuncs.com/';
}
//本地环境
if(ENV==0){
    eduUlr = 'http://127.0.0.1:8086/';
    caeaUrl = 'http://127.0.0.1:8885';
    webLoginUrl = 'http://localhost:8889/login?isShareSite=1'; 
    webPersonalCenterUrl = 'http://localhost:8889/personalCenter?isShareSite=1'; 
    webRealInfoUrl = 'http://localhost:8889/realInfo?isShareSite=1'; 
    authorUrl = '//ceshi.artapp.cn/AuthServer'; //frp.artapp.cn/AuthServer
    redirect_uri='http://127.0.0.1:8086/callback.html';
    ossurl = 'https://artapp-test-bucket.oss-cn-beijing.aliyuncs.com/';
}

//开发环境（测试环境）
if (process.env.NODE_ENV == 'development') {
    domainurl = '/test';//代理跨域 product test
}
//正式环境（生产环境）
else if (process.env.NODE_ENV == 'production') {
    domainurl = '';
}

const base = {
    default: domainurl + restPath,
    eduUlr: eduUlr,
    caeaUrl:caeaUrl,
    shequUrl: shequUrl,
    webLoginUrl: webLoginUrl,
    webPersonalCenterUrl: webPersonalCenterUrl,
    webRealInfoUrl: webRealInfoUrl,
    authorUrl:authorUrl,
    redirect_uri:redirect_uri,
    ossurl: ossurl,
}

export default base;